import { propsToClasses } from '../utils';
var styles = {
  "size-small": "Text-size-small_wppb0",
  "size-base": "Text-size-base_3CRhE",
  "size-big": "Text-size-big_2u5h3",
  "size-bigger": "Text-size-bigger_2_oSv",
  "weight-regular": "Text-weight-regular_Flodb",
  "weight-semibold": "Text-weight-semibold_gjQ4f",
  "fontStyle-normal": "Text-fontStyle-normal_3z9HE",
  "fontStyle-italic": "Text-fontStyle-italic_2DEGn",
  "fontStyle-oblique": "Text-fontStyle-oblique_Ai97Q",
  "fontFamily-text": "Text-fontFamily-text_3ykwz",
  "fontFamily-display": "Text-fontFamily-display_3uSzK",
  "fontFamily-monospace": "Text-fontFamily-monospace_3y4Gg",
  "color-inherit": "Text-color-inherit_2tHFd",
  "color-white": "Text-color-white_MQZPd",
  "color-weak": "Text-color-weak_32tBL",
  "color-base": "Text-color-base_3T7Dg",
  "color-link": "Text-color-link_1_3AZ",
  "color-informative": "Text-color-informative_1c0sD",
  "color-positive": "Text-color-positive_3A_z7",
  "color-notice": "Text-color-notice_3hutX",
  "color-negative": "Text-color-negative_2EwDu",
  "color-highlight": "Text-color-highlight_13BDC",
  "color-promotional": "Text-color-promotional_19Sw_",
  "color-light": "Text-color-light_15Jq_",
  "color-green": "Text-color-green_3nuqk",
  "color-blue": "Text-color-blue_1jlTQ",
  "color-disabled": "Text-color-disabled_3gw9l",
  "color-grey-lighter": "Text-color-grey-lighter_19HYp",
  "color-grey-light": "Text-color-grey-light_3twW5",
  "color-grey": "Text-color-grey_46jch",
  "color-grey-dark": "Text-color-grey-dark_2Tgli",
  "color-grey-darker": "Text-color-grey-darker_y_w5-",
  "color-anthracite": "Text-color-anthracite_2apnl",
  "color-red": "Text-color-red_hWeco",
  "color-red-dark": "Text-color-red-dark_3X0H4",
  "color-info": "Text-color-info_1dilv",
  "color-success": "Text-color-success_35AK5",
  "color-warning": "Text-color-warning_2ICXt",
  "color-danger": "Text-color-danger_2KF0Y",
  "color-promotional-light": "Text-color-promotional-light_20yyz",
  "color-promotional-dark": "Text-color-promotional-dark_2Gh3c",
  "color-promotional-darker": "Text-color-promotional-darker_3t_9S",
  "hoverColor-inherit": "Text-hoverColor-inherit_2sFum",
  "hoverColor-white": "Text-hoverColor-white_DWuRn",
  "hoverColor-green": "Text-hoverColor-green_3Nfg9",
  "hoverColor-blue": "Text-hoverColor-blue_1liiC",
  "align-start": "Text-align-start_2Eyi0",
  "align-end": "Text-align-end_3rH75",
  "align-center": "Text-align-center_1GS3O",
  "transform-capitalize": "Text-transform-capitalize_1VWMn",
  "transform-lowercase": "Text-transform-lowercase_3ONPj",
  "transform-uppercase": "Text-transform-uppercase_1NM52",
  "decoration-overline": "Text-decoration-overline_BKeCy",
  "decoration-underline": "Text-decoration-underline_2hYV8",
  "decoration-line-through": "Text-decoration-line-through_3Q9c8",
  "overflow-truncate": "Text-overflow-truncate_mwwKi",
  "overflow-break": "Text-overflow-break_Y01Ht",
  "display-inline": "Text-display-inline_3GL88",
  "display-inline-block": "Text-display-inline-block_TkKhM",
  "display-block": "Text-display-block_JR1Py",
  "select-auto": "Text-select-auto_1o9IL",
  "select-text": "Text-select-text_27_F4",
  "select-none": "Text-select-none_1Coyq",
  "select-all": "Text-select-all_3jtYZ",
  "listStyleType-disc": "Text-listStyleType-disc_35o3B",
  "listStyleType-none": "Text-listStyleType-none_2GFpz"
};
export function Documentation(props) {}
export function useText(props) {
  const {
    size,
    weight,
    fontStyle,
    fontFamily,
    color,
    hoverColor,
    align,
    transform,
    decoration,
    overflow,
    display,
    select,
    listStyleType,
    ...extraProps
  } = props;
  const classes = propsToClasses(props, styles);
  return [classes, extraProps];
}